import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import moment from 'moment';
import { OrderService } from '@app/api/api';
import { rest } from 'lodash';

import { GoogleAnalyticsService } from '@app/api/api';

declare var Chart: any;

@Component({
  selector: 'meu-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  totalOrderWaitingConfirm = 0;
  totalOrderPickingUpGoods = 0;
  totalOrderHandingOverShipping = 0;
  totalOrderDeliverySuccessful = 0;
  totalOrderCanceled = 0;

  // range Date
  rangeDate;
  startDateOfWeek;
  endDateOfWeek;

  totalMoney = 0;
  percentTotalMoney = 0;
  isIncreaseTotalMoney = true;

  totalOrder = 0;
  percentTotalOrder = 0;
  isIncreaseTotalOrder = true;

  totalQuotePrice = 0;
  percentTotalQuotePrice = 0;
  isIncreaseTotalQuotePrice = false;

  totalConversionRate = 0;
  percentTotalConversionRate = 0;
  isIncreaseTotalConversionRate = true;

  listProduct = [];
  displayedColumns: string[] = ['index', 'name', 'created', 'price', 'extend_step_name'];

  pagesize = 10;
  pageIndex = 1;
  total;
  totalVisits;
  dailyTrafic; // bieu do tron
  averageOrderValue;
  customerLifetimeValue;
  customerRetentionRate;
  cutomerMobileConversionRate;
  pltDisplay;
  cartAbandonmentRate;
  pageSizeOptions: number[] = [5, 10, 20, 100];
  customerAcquisitionCost: any = '—';
  totalMarketingCost: number = null;
  marketingSaved: boolean = false;

  @ViewChild('lineChart', { static: true }) lineChart: ElementRef;
  line_Chart: any;

  @ViewChild('trafficPieChart', { static: true })
  trafficPieChart: ElementRef;

  trafficPie_Chart: any;

  constructor(
    private currencyPipe: CurrencyPipe,
    private orderService: OrderService,
    private cdr: ChangeDetectorRef,
    private googleAnalytic: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    this.startDateOfWeek = new Date(
      moment.utc().local().startOf('isoWeek').format('YYYY-MM-DD 00:00:00').toString()
    );
    this.endDateOfWeek = new Date(
      moment().utc().local().endOf('isoWeek').format('YYYY-MM-DD 00:00:00').toString()
    );
    this.rangeDate = {
      begin: this.startDateOfWeek,
      end: this.endDateOfWeek,
    };
    this.callAPI();
    this.measurePlt();
  }

  callAPI() {
    this.getTotalStatistic();
    this.getListProduct();
    this.getTotalTraffic();
    this.getOrderAverageValue();
    this.getCustomerLifetimeValue();
    this.getCustomerRetentionRate();
    this.getTrafficByChannel();
    this.getCutomerMobileConversionRate();
    this.getCartAbandonmentRate();
    // Only call CAC API when total marketing cost is provided
    if (this.totalMarketingCost !== null && this.totalMarketingCost !== undefined) {
      this.getCustomerAcquisitionCost();
    } else {
      this.customerAcquisitionCost = '';
    }
    //this.renderChart()
  }

  getCustomerAcquisitionCost() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    // API signature requires totalMarketingCost as first parameter
    if (this.totalMarketingCost === null || this.totalMarketingCost === undefined) {
      return;
    }
    this.googleAnalytic
      .apiGoogleAnalyticsCustomerAcquisitionCostGet(this.totalMarketingCost, startDate, endDate)
      .subscribe((res) => {
        if (res && res.success) {
          const val =
            res.data && res.data.customerAcquisitionCost !== undefined
              ? res.data.customerAcquisitionCost
              : res.data;
          if (val === undefined || val === null || val === '') {
            this.customerAcquisitionCost = '';
          } else if (!isNaN(Number(val))) {
            this.customerAcquisitionCost = Number(val);
          } else {
            this.customerAcquisitionCost = val;
          }
        }
        this.cdr.detectChanges();
      });
  }

  onTotalMarketingCostChange(value: any) {
    this.marketingSaved = false;
    const n = Number(value);
    this.totalMarketingCost = isNaN(n) ? null : n;
  }

  saveTotalMarketingCost() {
    // Mark saved and fetch updated CAC using provided totalMarketingCost
    this.marketingSaved = true;
    this.cdr.detectChanges();
    if (this.totalMarketingCost !== null && this.totalMarketingCost !== undefined) {
      this.getCustomerAcquisitionCost();
    }
  }

  getCartAbandonmentRate() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    this.googleAnalytic
      .apiGoogleAnalyticsCartAbandonmentRateGet(startDate, endDate)
      .subscribe((res) => {
        if (res.success) {
          this.cartAbandonmentRate = res.data.abandonmentRate;
        }
      });
  }
  formatDateLocal(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  getTotalTraffic() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    this.googleAnalytic.apiGoogleAnalyticsTrafficGet(startDate, endDate).subscribe((res) => {
      if (res.success) {
        this.totalVisits = res.data.totalUsers;
      }
    });
  }

  getOrderAverageValue() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    this.googleAnalytic
      .apiGoogleAnalyticsAverageOrderValueGet(startDate, endDate)
      .subscribe((res) => {
        if (res.success) {
          this.averageOrderValue = res.aov;
        }
      });
  }
  getCustomerLifetimeValue() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    this.googleAnalytic
      .apiGoogleAnalyticsCustomerLifetimeValueGet(startDate, endDate)
      .subscribe((res) => {
        if (res.success) {
          this.customerLifetimeValue = res.clv;
        }
      });
  }

  getCustomerRetentionRate() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    this.googleAnalytic
      .apiGoogleAnalyticsCustomerRetentionRateGet(startDate, endDate)
      .subscribe((res) => {
        if (res.success) {
          this.customerRetentionRate = res.crr;
        }
      });
  }

  getCutomerMobileConversionRate() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);
    this.googleAnalytic
      .apiGoogleAnalyticsMobileConversionRateGet(startDate, endDate)
      .subscribe((res) => {
        if (res.success) {
          this.cutomerMobileConversionRate = res.mcr;
          console.log('mcr', this.cutomerMobileConversionRate);
        }
      });
  }

  getTrafficByChannel() {
    const startDate = this.formatDateLocal(this.rangeDate.begin);
    const endDate = this.formatDateLocal(this.rangeDate.end);

    this.googleAnalytic.apiGoogleAnalyticsTrafficSourcesGet(startDate, endDate).subscribe((res) => {
      if (res.success) {
        this.renderTrafficPercentPie(res.data);
      }
    });
  }

  renderTrafficPercentPie(data: any[]) {
    const labels = data.map((x) => x.channelGrouping);
    const values = data.map((x) => x.sessions);

    const total = values.reduce((a, b) => a + b, 0);

    if (this.trafficPie_Chart) {
      this.trafficPie_Chart.destroy();
    }

    this.trafficPie_Chart = new Chart(this.trafficPieChart.nativeElement, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: ['#4CAF50', '#03A9F4', '#FFC107', '#FF9800', '#9C27B0', '#F44336'],
          },
        ],
      },
      options: {
        responsive: true,
        cutoutPercentage: 60,
        legend: {
          position: 'right',
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const value = data.datasets[0].data[tooltipItem.index];
              const percent = ((value / total) * 100).toFixed(1);
              return `${data.labels[tooltipItem.index]}: ${percent}% (${value} sessions)`;
            },
          },
        },
      },
    });
  }
  getTotalStatistic() {
    this.orderService
      .apiOrdersStepSumaryGet(this.rangeDate.begin, this.rangeDate.end)
      .subscribe((res) => {
        this.totalMoney = res.data.dataInRange.income;
        this.totalOrder = res.data.dataInRange.oders;
        this.totalQuotePrice = res.data.dataInRange.quotationRequest;
        this.totalConversionRate = res.data.dataInRange.convertingRate;

        this.totalOrderWaitingConfirm = res.data.summaryStepData.orderSuccess;
        this.totalOrderPickingUpGoods = res.data.summaryStepData.loading;
        this.totalOrderHandingOverShipping = res.data.summaryStepData.shipping;
        this.totalOrderDeliverySuccessful = res.data.summaryStepData.deliverySuccess;
        this.totalOrderCanceled = res.data.summaryStepData.cancel;
        let labels = [];
        let dataMoney = [];
        let dataOrder = [];

        for (let i = 0; i < res.data.lstIncomeVsOrder.length; i++) {
          let item = res.data.lstIncomeVsOrder[i];
          labels.push(item.date);
          dataMoney.push(item.income);
          dataOrder.push(item.order);
        }

        let maxMoney = Math.max(...dataMoney);
        if (maxMoney == 0) maxMoney = 1;
        maxMoney = Math.ceil(maxMoney * 1.5);
        maxMoney = maxMoney % 2 == 0 ? maxMoney : maxMoney + 1;

        let maxOrder = Math.max(...dataOrder);
        if (maxOrder == 0) maxOrder = 1;
        maxOrder = Math.ceil(maxOrder * 1.5);
        maxOrder = maxOrder % 2 == 0 ? maxOrder : maxOrder + 1;

        let arrPercentOrder = [];
        dataOrder.forEach((el) => {
          arrPercentOrder.push({
            value: (((el * 100) / maxOrder) * maxMoney) / 100,
            label: el,
          });
        });
        let datasets = [
          {
            fill: false,
            type: 'line',
            label: 'Doanh thu',
            borderColor: '#ff4689',
            borderWidth: 2,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 12,
            pointBackgroundColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
            pointBorderColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
            pointHoverBackgroundColor: '#ff4689',
            pointHoverBorderColor: Chart.helpers.color('#000000').alpha(0.1).rgbString(),
            data: dataMoney,
          },
          {
            fill: false,
            type: 'line',
            label: 'Đơn hàng',
            borderColor: '#4277ff',
            borderWidth: 2,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 12,
            pointBackgroundColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
            pointBorderColor: Chart.helpers.color('#000000').alpha(0).rgbString(),
            pointHoverBackgroundColor: '#4277ff',
            pointHoverBorderColor: Chart.helpers.color('#000000').alpha(0.1).rgbString(),
            data: arrPercentOrder.map((x) => x.value),
            dataTooltip: arrPercentOrder.map((x) => x.label),
          },
        ];

        let data = {
          labels: labels,
          datasets: datasets,
        };

        if (this.line_Chart != undefined) {
          this.line_Chart.destroy();
        }

        let w = (window as any).$(window).width();

        this.line_Chart = new Chart(this.lineChart.nativeElement, {
          type: 'line',
          data: data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            scales: {
              xAxes: [
                {
                  categoryPercentage: 0.35,
                  barPercentage: 0.7,
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: 'Month',
                  },
                  gridLines: {
                    color: '#EBEDF2',
                    drawBorder: false,
                    offsetGridLines: false,
                    drawTicks: false,
                    borderDash: [3, 0],
                    zeroLineWidth: 1,
                    zeroLineColor: '#EBEDF2',
                    zeroLineBorderDash: [3, 0],
                  },
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    padding: 10,
                    autoSkip: true,
                    maxRotation: 0,
                    minRotation: 0,
                    callback: function (tick, index, ticksArray) {
                      if (w < 570) {
                        return moment(tick).format('DD/MM');
                      } else return moment(tick).format('DD/MM/YYYY');
                    },
                  },
                },
              ],
              yAxes: [
                {
                  categoryPercentage: 0.35,
                  barPercentage: 0.7,
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: 'Value',
                  },
                  gridLines: {
                    color: '#EBEDF2',
                    drawBorder: false,
                    offsetGridLines: false,
                    drawTicks: false,
                    borderDash: [3, 0],
                    zeroLineWidth: 2,
                    zeroLineColor: '#EBEDF2',
                    zeroLineBorderDash: [3, 0],
                  },
                  ticks: {
                    max: maxMoney,
                    stepSize: maxMoney / 2,
                    display: true,
                    beginAtZero: true,
                    padding: 10,
                    callback: (value) => (w >= 570 ? this.transformCurrency(value) : ' '),
                  },
                },
                {
                  type: 'linear',
                  position: 'right',
                  categoryPercentage: 0.35,
                  barPercentage: 0.7,
                  display: true,
                  scaleLabel: {
                    display: false,
                    labelString: 'Value',
                  },
                  gridLines: {
                    color: '#EBEDF2',
                    drawBorder: false,
                    offsetGridLines: false,
                    drawTicks: false,
                    borderDash: [3, 0],
                    zeroLineWidth: 2,
                    zeroLineColor: '#EBEDF2',
                    zeroLineBorderDash: [3, 0],
                  },
                  ticks: {
                    max: maxOrder,
                    stepSize: maxOrder / 2,
                    display: true,
                    beginAtZero: true,
                    padding: 10,
                    callback: (value) => (w >= 570 ? value : ' '),
                  },
                },
              ],
            },
            title: {
              display: false,
            },
            hover: {
              mode: 'index',
            },
            tooltips: {
              enabled: true,
              intersect: false,
              mode: 'nearest',
              bodySpacing: 5,
              yPadding: 10,
              xPadding: 10,
              caretPadding: 0,
              displayColors: false,
              cornerRadius: 4,
              footerSpacing: 0,
              titleSpacing: 0,
              yAlign: 'bottom',
              callbacks: {
                title: function (tooltipItem, data) {
                  return moment(tooltipItem[0].label).format('DD/MM/YYYY');
                },
                label: function (tooltipItem, data) {
                  if (tooltipItem.datasetIndex == 0) {
                    return (
                      'Doanh thu: ' +
                      new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'VND',
                      }).format(tooltipItem.value)
                    );
                  } else {
                    return 'Đơn hàng: ' + data.datasets[1].dataTooltip[tooltipItem.index];
                  }
                },
              },
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 5,
                bottom: 5,
              },
            },
          },
        });
      });
  }

  getListProduct() {
    this.orderService
      .apiOrdersSummaryGet(
        this.rangeDate.begin,
        this.rangeDate.end,
        '',
        '-created_at',
        this.pageIndex,
        this.pagesize
      )
      .subscribe((res) => {
        this.listProduct = [];
        res.data.collection.forEach((element) => {
          let product = {
            created: element.created_at
              ? moment.utc(element.created_at).local().format('DD/MM/YYYY HH:mm:ss')
              : '',
            id: element.id,
            default_image: '',
            name: element.extend_product_name,
            sku: '',
            price: element.total_price,
            quantity_sold: element.extend_total_product,
            extend_step_name: element.extend_step_name,
            extend_step_color: element.extend_step_color,
          };
          this.listProduct.push(product);
        });
        this.total = res.data.total;
        // this.pageIndex = res.data.pageIndex; // Tắt
        // this.pagesize = res.data.pagesize; // Tắt
        this.cdr.detectChanges();
      });
  }

  inlineRangeChange(event) {
    let beginDate = moment(event.begin).format('YYYY-MM-DD');
    let endDate = moment(event.end).format('YYYY-MM-DD');
    if (endDate < beginDate) {
      this.rangeDate = {
        begin: event.end,
        end: event.begin,
      };
    } else {
      this.rangeDate = {
        begin: event.begin,
        end: event.end,
      };
    }
    this.callAPI();
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getListProduct();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pagesize = newSize;
    this.pageIndex = 1;
    this.getListProduct();
  }

  transformCurrency(value) {
    if (value == '' || value == null || value == undefined) {
      return '0';
    }
    let val = value.toString();
    if (val != null) {
      val = val.replace(/[^0-9.-]+/g, '');
      return this.currencyPipe.transform(val, 'VND', '');
    }
  }

  measurePlt() {
    try {
      let plt: number = null;
      if (window && (window as any).performance) {
        const perf: any = (window as any).performance;
        let nav: any = null;
        if (perf.getEntriesByType) {
          const entries = perf.getEntriesByType('navigation');
          nav = entries && entries.length ? entries[0] : null;
        }

        if (nav && typeof nav.loadEventEnd === 'number' && nav.loadEventEnd > 0) {
          plt = Math.round(nav.loadEventEnd - (nav.startTime || 0));
        } else if (perf.timing) {
          const t = perf.timing;
          if (t.loadEventEnd && t.navigationStart) {
            plt = Math.round(t.loadEventEnd - t.navigationStart);
          } else {
            plt = Math.round(perf.now());
          }
        } else {
          plt = Math.round(perf.now());
        }
      }
      if (plt == null || isNaN(plt)) {
        this.pltDisplay = 'N/A';
      } else {
        this.pltDisplay = plt + ' ms';
      }
    } catch (e) {
      this.pltDisplay = 'N/A';
    }
    this.cdr.detectChanges();
  }

  subStringName(name) {
    if (name) {
      let l = name.toString().length;
      if (l > 55) {
        return name.substring(0, 55) + '...';
      } else {
        return name;
      }
    }
    return '';
  }
}
